<div class="modal-content modal-milvus" style="zoom: 0.85;">
    <ngx-spinner></ngx-spinner>
    <div class="modal-header-milvus align-items-center dark-back">
        <div class="col-6 header-col" style="margin-top: -10px; margin-left: -6px;">
            <span class="modal-title" id="modal-title-default">{{'MENSAGENS' | translate}}</span>
        </div>
        <div class="col-6 header-col" style="margin-top: -10px;">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
                <i class="mdi mdi-close"></i>
            </button>
        </div>
    </div>

    <div class="modal-body divider-top px-0" style="overflow: hidden; padding: 0 !important;">
        <div class="row w-100 ml-0">
            <div class="col-12 dark-back">
                <!-- informacoes do chat -->
                <div class="row line-data" style="margin-bottom: 10px; margin-top: 10px !important;">
                    <div *ngIf="chatSelecionado" class="d-flex col-6 mt-2">
                        <div>
                            <img alt="Image placeholder" [src]="chatSelecionado.avatar || 'assets/img/theme/user.png'"
                                class="avatar rounded-circle mt-1 mr-3" style="max-width: 49px;" (click)="abrirInfoContato(chatSelecionado)" />
                        </div>
                        <div>
                            <div class="chat-name">
                                {{chatSelecionado.contato?.descricao ? chatSelecionado.contato?.descricao : 
                                chatSelecionado.numero_contato ? chatSelecionado.numero_contato : ''}} 
                                {{chatSelecionado.cliente && chatSelecionado.cliente.text ? '- ' + chatSelecionado.cliente.text : null }}
                            </div>
                            <div class="chat-name">
                                {{chatSelecionado.contato?.celular ?
                                (chatSelecionado.contato?.celular | mask:'(00) 00000-0000 || (00) 0000-0000') : chatSelecionado.contato?.telefone 
                                ? (chatSelecionado.contato?.telefone | mask:'(00) 0000-0000') : ''}}
                                {{chatSelecionado.contato?.email ? '- ' + chatSelecionado.contato?.email : chatSelecionado.email ?
                                '- ' + chatSelecionado.email : ''}}
                            </div>
                            <div class="chat-lastmsg" style="cursor: pointer;" *ngIf="chatSelecionado.chamado_vinculado"
                                (click)="openTicket(chatSelecionado.chamado_vinculado)">
                                <i style="margin-top: 5px;" *ngIf="chatSelecionado.chamado_vinculado"
                                    class="fas fa-ticket-alt fa-lg"></i> 
                                    {{ chatSelecionado.chamado_vinculado ? ' #'+chatSelecionado.chamado_vinculado.codigo : ''}}
                            </div>
                            <div class="chat-lastmsg">
                                {{ 'ULTIMA_INTERACAO' | translate }} {{chatSelecionado.data_mensagem}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row dark-back w-100 ml-0" style="height: 585px;">
            <div class="col-12 darker-back divider-top p-0" style="max-height: 100%;">
                <div id="chat-msgs">
                    <div #scrollMe id="msg-item" class="msg-item" style="bottom: 152px;" (scroll)="onScroll($event)">
                        <div *ngIf="mais_registros; else semMaisConversas" class="w-100 d-flex justify-content-center m-3">
                            <button type="button" class="btn-carregar-mais-conversas" (click)="carregarMaisConversas()">
                                <i class="fa-regular fa-arrow-up mr-3"></i>
                                <span [translate]="'VER_CONVERSAS_ANTERIORES'"></span>
                            </button>
                        </div>
                        <ng-template #semMaisConversas>
                            <div *ngIf="!mais_registros && pagina > 1" class="w-100 d-flex justify-content-center m-3">
                                <div class="btn-sem-mais-conversas">
                                    <i class="fa-sharp fa-regular fa-xmark font-20 mr-3"></i>
                                    <span [translate]="'SEM_CONVERSAS_ANTERIORES'"></span>
                                </div>
                            </div>
                        </ng-template>
                        <div #messages class="msg" *ngFor="let chat of mensagensChat">
                            <div *ngIf="mais_registros || pagina > 1" class="w-100 d-flex justify-content-center m-3">
                                <div class="d-flex btn-conversa-anterior">
                                    <i class="fa-solid fa-clock-rotate-left mr-3"></i>
                                    <span [translate]="'CONVERSA_ANTERIOR'"></span>
                                    <span>-</span>
                                    <span>{{chat.data_chat | date:'dd/MM/YYYY'}}</span>
                                    <span>-</span>
                                    <span>{{chat.data_chat | date:'HH:mm:ss'}}</span>
                                </div>
                            </div>
                            <ng-container *ngFor="let msg of chat.listaMensagens; let i = index; let last = last">
                                <!-- Separação de anexos com legenda -->
                                <ng-container *ngIf="msg.tipo === 'anexo' && msg.msg_legenda && !msg.resposta_enviado_por; else msgComum">
                                    <div [id]="'msg-'+i" [ngbTooltip]="msg.formatedBody.length > 50 ? msg.formatedBody : ''"
                                        (click)="visualizarArquivo(msg, $event)"
                                        class="msg-destino text-left" style="white-space: pre-line; word-break: break-word;">
                                        <div class="msg-anexo-com-legenda" [innerHtml]="msg?.formatedBody"></div>
                                        <div class="mt-2" [innerHTML]="msg?.msg_legenda"></div>
                                        <div class="text-right msg-time">
                                            {{msg?.data_mensagem | date:'dd/MM/YYYY HH:mm:ss'}}
                                        </div>
                                    </div>
                                </ng-container>
                                <ng-template #msgComum>
                                    <div [id]="'msg-'+i"
                                        [ngClass]="msg.enviado_por === 'robo' || msg.enviado_por === 'tecnico' ? 'text-right' : 'text-left'">
                                        <div container=".modal" [ngbTooltip]="msg.formatedBody.length > 50 ? msg.formatedBody : ''"
                                            [innerHtml]="msg.formatedBody"
                                            (click)="visualizarArquivo(msg, $event)"
                                            class="msg-origem msg-transferencia text-left"
                                            *ngIf="msg.is_transferencia && msg.formatedBody"
                                            style="white-space: pre-line; word-break: break-word;">
                                        </div>
                                        <div container=".modal" [ngbTooltip]="msg.autor ? msg.autor.nome : msg.user"
                                            [innerHtml]="msg.formatedBody"
                                            (click)="visualizarArquivo(msg, $event)"
                                            class="msg-origem text-left"
                                            *ngIf="(msg.enviado_por === 'robo' || msg.enviado_por === 'tecnico') && msg.formatedBody"
                                            style="white-space: pre-line; word-break: break-word;">
                                        </div>
                                        <div container=".modal" [ngbTooltip]="chatSelecionado.contato?.descricao ? chatSelecionado.contato?.descricao : 
                                        chatSelecionado.numero_contato ? chatSelecionado.numero_contato : msg.autor ? msg.autor.nome : msg.user"
                                            [innerHtml]="msg.formatedBody"
                                            class="msg-destino text-left" style="white-space: pre-line; word-break: break-word;"
                                            *ngIf="msg.enviado_por === 'cliente' && msg.formatedBody">
                                        </div>
                                    </div>
                                </ng-template>
                                {{last ? scrollToBottom() : ''}}
                            </ng-container>
                        </div>
                    </div>
                    <div class="darker-back input-box">
                        <div class="row" style="padding: 14px;">
                            <div class="col-12 justify-content-center">
                                <span>
                                    {{ ('HISTORICO_CONVERSAS' | translate)}}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <button *ngIf="verificaMostraScrollBtn()" type="button" class="btn btn-sm small-circled-btn btn-chat-scroll-bottom" (click)="goToBottom()" [ngbTooltip]="'DESCER_FIM' | translate" container=".modal" placement="top-right" tooltipClass="tooltip-btn-scroll-chat">
            <i class="fa-sharp fa-solid fa-chevron-down"></i>
        </button>
    </div>
</div>